export const lowerCase = (data: string): string => {
  return data.toLowerCase();
};

export function formatTitle(str: string) {
  return str
    ?.replace(/\//g, "") // replace all - with space
    ?.replace(/-/g, " ") // Replace all hyphens with spaces
    ?.split(" ") // Split the string into words
    ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    ?.join(" "); // Join the words back together with spaces
}

export function capitalizeFirstLetter(str: string) {
  return str?.charAt(0)?.toUpperCase() + str?.slice(1);
}

export function capitalizeAfterComma(str: string) {
  return str
    ?.split(",")
    .map((word, index) => {
      if (index > 0) {
        return word?.trim()?.charAt(0)?.toUpperCase() + word?.slice(1);
      } else {
        return word?.trim();
      }
    })
    .join(", ");
}

export function formatAndCapitalizeString(str: string) {
  return (
    str &&
    str?.replace(/-/g, " ")?.replace(/\b\w/g, (match) => match?.toUpperCase())
  );
}

export function truncateText(text: string, limit = 10) {
  if (text?.length <= limit) {
    return text;
  }

  // Find the last space within the limit
  const truncated = text?.substring(0, limit);
  const lastSpaceIndex = truncated?.lastIndexOf(" ");

  // If a space is found, truncate at the last space, else truncate at the limit
  return lastSpaceIndex > 0
    ? text?.substring(0, lastSpaceIndex) + "..."
    : text?.substring(0, limit) + "...";
}

export function isValidEmail(email: string) {
  // Regular expression for validating an Email
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return emailRegex.test(email);
}

export const getRedirectPath = () => {
  const path = window.location.pathname;
  return path.startsWith("/admin")
    ? "/"
    : path.startsWith("/leader")
    ? "/"
    : "/";
};

export const roleOptions = [
  { id: 4, name: "Data User" },
  { id: 2, name: "Organization Leader" },
  { id: 3, name: "Organization Controller" },
  { id: 1, name: "Admin" },
];

export const userRoleOptions = [
  { id: 4, name: "Data User" },
  { id: 2, name: "Organization Leader" },
  { id: 3, name: "Organization Controller" },
];

// export const currentWindowPath = (path: string): string => {
//   const pathMapping: Record<string, string> = {
//     "/admin/login": "ADMIN",

//     "/leader/login": "LEADER",
//   };
//   return pathMapping[path] || "USER";
// };

export const sideDrawerTypes = {
  user: "User",
  organization: "Organization",
  category: "Category",
  budget: "Budget",
  dataElement: "Data Element",
  dataEntry: "Data Entry",
};

export const tabTitle = {
  "/admin/dashboard": "Dashboard",
  "/admin/organizations": "Organizations",
  "/admin/users": "Users",
  "/admin/budgets": "Budgets",
  "/admin/categories": "Categories",
  "/admin/data-elements": "Data Elements",
  "/admin/reports": "Reports",
  "/admin/data-review": "Review",
  "/admin/requests": "Requests",
  "/admin/submission-status": "Submission",
  "/privacy": "Privacy Policy",
  "/terms-and-conditions": "T&C",
  "/admin/view/user/:id": "View User",
  "/admin/view/data-element/:id": "View Data Element",
  "/leader/dashboard": "Dashboard",
  "/leader/organizations": "Organization",
  "/leader/users": "Users",
  "/leader/budgets": "Budgets",
  "/leader/data-elements": "Data Elements",
  "/leader/reports": "Reports",
  "/leader/data-review": "Data Review",
  "/leader/submission-status": "Submission",
  "/leader/view-organization/:id": "View Organization",
  "/leader/assign-element": "Assign Elements",
  "/controller/dashboard": "Dashboard",
  "/controller/organizations": "Organization",
  "/controller/users": "Users",
  "/controller/budgets": "Budgets",
  "/controller/data-elements": "Data Elements",
  "/controller/reports": "Reports",
  "/controller/data-review": "Data Review",
  "/controller/submission-status": "Submission",
  "/controller/view-organization/:id": "View Organization",
  "/controller/assign-element": "Assign Elements",
  "/dashboard": "Dashboard",
  "/organizations": "Organizations",
  "/data-elements": "Elements",
  "/data-entry": "Data Entry",
  "/password-change": "Change Password",
};

export const monthSelection = [
  { name: "January", value: 1 },
  { name: "February", value: 2 },
  { name: "March", value: 3 },
  { name: "April", value: 4 },
  { name: "May", value: 5 },
  { name: "June", value: 6 },
  { name: "July", value: 7 },
  { name: "August", value: 8 },
  { name: "September", value: 9 },
  { name: "October", value: 10 },
  { name: "November", value: 11 },
  { name: "December", value: 12 },
];

export const dataelementsIntervals = [
  // {
  //   id: 1,
  //   Interval_Name: "Second",
  //   Interval_Description: "Second",
  //   Interval_SQLDD: "SECOND",
  // },
  // {
  //   id: 2,
  //   Interval_Name: "Minute",
  //   Interval_Description: "Minute",
  //   Interval_SQLDD: "MINUTE",
  // },
  // {
  //   id: 3,
  //   Interval_Name: "Hour",
  //   Interval_Description: "Hour",
  //   Interval_SQLDD: "HOUR",
  // },
  // {
  //   id: 4,
  //   Interval_Name: "Day",
  //   Interval_Description: "Day",
  //   Interval_SQLDD: "DAY",
  // },
  // {
  //   id: 5,
  //   Interval_Name: "WorkDay",
  //   Interval_Description: "WorkDay",
  //   Interval_SQLDD: "WORKDAY",
  // },
  {
    id: 6,
    Interval_Name: "Week",
    Interval_Description: "Week",
    Interval_SQLDD: "WEEK",
  },
  {
    id: 7,
    Interval_Name: "Month",
    Interval_Description: "Month",
    Interval_SQLDD: "MONTH",
  },
  // {
  //   id: 8,
  //   Interval_Name: "Year",
  //   Interval_Description: "Year",
  //   Interval_SQLDD: "YEAR",
  // },
];

export const elementInterval = {
  1: "Second",
  2: "Minute",
  3: "Hour",
  4: "Day",
  5: "WorkDay",
  6: "Week",
  7: "Month",
  8: "Year",
};

export const getIntervalNameById = (id: number) => {
  const interval = dataelementsIntervals.find((item) => item.id === id);
  return interval ? interval.Interval_Name : "Unknown"; // Returns "Unknown" if ID not found
};

export const monthName = {
  1: "January",
  2: "February",
  3: "March",
  4: "April",
  5: "May",
  6: "June",
  7: "July",
  8: "August",
  9: "September",
  10: "October",
  11: "November",
  12: "December",
};

export const showRole = {
  1: "Admin",
  2: "Organization Leader",
  3: "Organization Controller",
  4: "Data User",
};

export const formatToCST = (dateString: string) => {
  if (!dateString) return "--";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "--";

  // Format the date part (27 Feb 2025)
  const formattedDate = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Chicago",
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(date);

  // Format the time part (HH:mm in CST)
  const formattedTime = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Chicago",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false, // 24-hour format
  }).format(date);

  return `${formattedDate.replace(",", "")} | ${formattedTime} CST`;
};

//This is to format data with this type 2025-03-17T05:59:35.000Z
export const formatDateToCST = (dateString: string) => {
  // Convert input string to a Date object
  const date = new Date(dateString.replace(" ", "T") + "Z");

  // Format the date part (18 Mar 2025)
  const formattedDate = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Chicago",
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(date);

  // Format the time part (6:37 in CST)
  const formattedTime = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Chicago",
    hour: "numeric", // Ensures no leading zero
    minute: "2-digit",
    hour12: true, // Ensures AM/PM format
  }).format(date);

  return `${formattedDate.replace(",", "")} | ${formattedTime
    .replace(" AM", "")
    .replace(" PM", "")} CST`;
};

//this format the date with this type 2024-12-31 18:30:00
export const formatDateTimeToCST = (dateString: string): string => {
  const date = new Date(dateString + " UTC"); // Ensure UTC interpretation
  const options: Intl.DateTimeFormatOptions = {
    timeZone: "America/Chicago", // CST time zone
    month: "short",
    day: "2-digit",
    year: "numeric", // Ensure it's "numeric" instead of string
    hour: "2-digit",
    minute: "2-digit",
    hour12: false, // Use 24-hour format and manually add CST
  };

  const formatter = new Intl.DateTimeFormat("en-US", options);
  const formattedDate = formatter.format(date);

  // Extract and rearrange parts for the final format
  const [month, day, year, time] = formattedDate.split(/[\s,]+/);
  const formattedTime = time.replace(/^(\d{2}):(\d{2})/, "$1:$2 CST"); // Ensure CST is appended

  return `${month} ${day} ${year} | ${formattedTime}`;
};

export const formatBackendDateToCST = (dateString: string): string => {
  const date = new Date(dateString); // Already in UTC

  // Format the date part
  const formattedDate = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Chicago",
    month: "short",
    day: "2-digit",
    year: "numeric",
  }).format(date);

  // Format the time part in 12-hour format (AM/PM removed later)
  const formattedTime = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Chicago",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  })
    .format(date)
    .replace(/\s?(AM|PM)/, ""); // Remove AM/PM

  return `${formattedDate.replace(",", "")} | ${formattedTime} CST`;
};

export const destructureOrganizationName = (str: string) => {
  if (!str) return "";
  if (str === "Signia") {
    return "Signia";
  } else {
    // Extract all uppercase letters (excluding the first character if it's already uppercase)
    const upperCases = str.slice(1).match(/[A-Z]/g)?.join("") || "";

    // Combine first character with extracted uppercase letters
    return (str.charAt(0) + upperCases).toUpperCase();
  }
};

export const formatMobileNumber = (
  phoneNumber?: string | number | null | any
): string => {
  if (
    !phoneNumber || // null, undefined, 0, false
    phoneNumber === "undefined" || // literal "undefined"
    phoneNumber === "null" || // literal "null"
    phoneNumber.toString().trim().length === 0 // empty string or spaces
  ) {
    return "-";
  }

  const number = phoneNumber.toString().replace(/^1/, ""); // Remove leading '1'
  return number.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3"); // Format as XXX-XXX-XXXX
};

export const formatProfileMobileNumber = (
  phoneNumber?: string | number | null
): string => {
  if (!phoneNumber) return "";

  const number = phoneNumber.toString().replace(/\D/g, ""); // Remove non-digits

  if (number.length === 11 && number.startsWith("1")) {
    return number.replace(/^1(\d{3})(\d{3})(\d{4})$/, "+1-$1-$2-$3");
  }

  if (number.length === 10) {
    return number.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
  }

  return number; // Return raw input for unsupported formats
};

export const formatSubmissionValue = (value: string, dataType: string) => {
  if (!value) return "-";

  switch (dataType.toLowerCase()) {
    case "money":
      return `$ ${parseFloat(value).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    case "decimal":
      return parseFloat(value).toFixed(2);
    case "integer":
      return parseInt(value, 10).toString();
    case "percent":
      return `${parseFloat(value).toFixed(2)} %`;
    default:
      return value;
  }
};
